<template>
  <div id="p-index">
    <div>
      <img
              src="../assets/images/big-logo.png"
              width="271px"
              height="32px"
              alt="腾讯青少年科技学院logo"
              @click="linkto('/home')"
      />
    </div>
    <p style="margin-top: 30px">站点建设中，很快回来...
    </p>
  </div>
</template>

<script>
export default {
  name: 'p-index',
  created() {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #p-index {
    margin: auto;
    text-align: center;
  }
</style>
